import "./_navigation.scss";

import {ReactElement} from "react";
import {useCallback, useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";

import ButtonHamburger from "@/components/ButtonHamburger/ButtonHamburger";
import {navItem} from "@/types/navigation";

function NavigationElement({
  navItems,
}: {
  navItems?: navItem[];
}): ReactElement | null {
  if (navItems !== undefined) {
    const navRef = useRef<HTMLDivElement>(null);
    const navListRef = useRef<(HTMLLIElement | null)[]>([]);
    const [isResponsive, setIsResponsive] = useState<boolean>(false);
    const [isActive, setIsActive] = useState<boolean>(false);

    const calculeMinNavSize = useCallback((): number => {
      const gapSize: number = 16;
      const paddingSize: number = 10;
      const nbItem = navItems?.length || 2;
      let totalSizeListNav = gapSize * (nbItem - 1) + paddingSize * nbItem;
      navListRef.current.forEach(listRef => {
        const firstChild = listRef?.firstChild as HTMLElement;

        if (firstChild?.offsetWidth) {
          totalSizeListNav += firstChild.offsetWidth;
        }
      });

      return totalSizeListNav;
    }, [navItems]);

    const updateNavDirection = useCallback((): void => {
      // active le responsive (buttonHambuger)
      // si la navigation est plus petite que l'espace nécessaire pour l'afficher
      if (
        navRef.current?.offsetWidth &&
        calculeMinNavSize() > navRef.current?.offsetWidth
      ) {
        setIsResponsive(true);
      } else {
        setIsResponsive(false);
      }
    }, [isResponsive]);

    useEffect(() => {
      updateNavDirection();
      let resizeTimeout: any;

      const handleResize = (): void => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateNavDirection, 200);
      };
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, [updateNavDirection]);
    const navigation = navItems?.map((element, index: number) => {
      return (
        <li
          key={`${index}-${element.libelle}`}
          ref={el => (navListRef.current[index] = el)}>
          <Link to={element.link}>{element.libelle}</Link>
        </li>
      );
    });

    return (
      <nav
        className={`navigation ${isResponsive ? "navResponsive" : ""}`}
        ref={navRef}>
        {isResponsive ? (
          <ButtonHamburger
            onClick={() => {
              setIsActive(!isActive);
            }}
          />
        ) : null}
        <ul className={`navigation-list ${isActive ? "active" : ""} `}>
          {navigation}
        </ul>
      </nav>
    );
  }
  return null;
}

export default NavigationElement;
